if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.productFormId = this.dataset.productFormId;
        this.moneyFormat = this.dataset.moneyFormat || '{{amount}}';

        this.qtyInput = this.querySelector('[data-qty-input]');
        this.priceEl = this.querySelector('[data-sticky-price]');
        this.imageEl = this.querySelector('[data-sticky-image]');

        this.querySelector('[data-qty-minus]').addEventListener('click', () => this.stepQuantity(-1));
        this.querySelector('[data-qty-plus]').addEventListener('click', () => this.stepQuantity(1));
        this.qtyInput.addEventListener('change', () => this.syncQuantity());
        this.querySelector('[data-sticky-submit]').addEventListener('click', () => this.submit());

        this.observeTrigger();

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          subscribe(PUB_SUB_EVENTS.variantChange, (payload) => {
            if (String(payload.data.sectionId) !== String(this.sectionId)) return;
            const variant = payload.data.variant;
            if (!variant) return;
            if (this.priceEl) this.priceEl.textContent = this.formatMoney(variant.price);
            if (this.imageEl && variant.featured_image) {
              this.imageEl.src = variant.featured_image.src || variant.featured_image;
            }
          });
        }
      }

      observeTrigger() {
        const trigger = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
        if (!trigger || !('IntersectionObserver' in window)) return;

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            this.hidden = entry.isIntersecting;
          });
        });
        observer.observe(trigger);
      }

      stepQuantity(delta) {
        const min = parseInt(this.qtyInput.min, 10) || 1;
        const next = Math.max(min, (parseInt(this.qtyInput.value, 10) || 1) + delta);
        this.qtyInput.value = next;
        this.syncQuantity();
      }

      syncQuantity() {
        const mainQtyInput = document.getElementById(`Quantity-${this.sectionId}`);
        if (mainQtyInput) {
          mainQtyInput.value = this.qtyInput.value;
          mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      submit() {
        this.syncQuantity();
        document.getElementById(`ProductSubmitButton-${this.sectionId}`)?.click();
      }

      formatMoney(cents) {
        cents = parseInt(cents, 10) || 0;
        const amount = (cents / 100).toFixed(2);
        const parts = amount.split('.');
        const grouped = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return this.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, `${grouped}.${parts[1]}`);
      }
    }
  );
}
